import {
  GET_INTERVIEW,
  GET_INTERVIEW_SUCCESS,
  GET_INTERVIEW_FAILURE,
  GET_FEEDBACK,
  GET_FEEDBACK_SUCCESS,
  GET_FEEDBACK_FAILURE,
} from "./types";

import {
  InterviewPayload,
  GetInterviewAction,
  GetInterviewSuccessAction,
  GetInterviewFailureAction,
  GetFeedbackAction,
  GetFeedbackSuccessAction,
  GetFeedbackFailureAction,
} from "../action/incbotFeedbackActionsTypes";

export const getInterview = (payload: InterviewPayload): GetInterviewAction => ({
  type: GET_INTERVIEW,
  payload,
});

export const getInterviewSuccess = (payload: any): GetInterviewSuccessAction => ({
  type: GET_INTERVIEW_SUCCESS,
  payload,
});

export const getInterviewFailure = (): GetInterviewFailureAction => ({
  type: GET_INTERVIEW_FAILURE,
});

export const getFeedback = (payload: InterviewPayload): GetFeedbackAction => ({
  type: GET_FEEDBACK,
  payload,
});

export const getFeedbackSuccess = (payload: any): GetFeedbackSuccessAction => ({
  type: GET_FEEDBACK_SUCCESS,
  payload,
});

export const getFeedbackFailure = (): GetFeedbackFailureAction => ({
  type: GET_FEEDBACK_FAILURE,
});
